import { useCallback, useMemo, useState } from 'react';
import { OPEN_DELETE_COMMENT_MODAL, deleteTimelineComment } from 'crm-events-data';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { TimelineCommentDeleteModalAsync } from 'crm-events-components/internal/comments/deleteModal/TimelineCommentDeleteModalAsync';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { getEngagementTypeForTracking } from 'crm-events-components/internal/helpers/trackingHelpers';
// @ts-expect-error Could not find a declaration file
import { useStoreDependency } from 'general-store';
import { EngagementDependency } from 'crm-events-data';
import { getDeleteCommentTranslations } from 'crm-events-components/internal/comments/deleteModal/TimelineCommentDeleteHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const useDeleteCommentModalActionHandler = () => {
  const [engagementIdToDeleteComment, setEngagementIdToDeleteComment] = useState(null);
  const [commentToDeleteId, setCommentToDeleteId] = useState(null);
  const engagementToDeleteComment = useStoreDependency(EngagementDependency, {
    engagementId: engagementIdToDeleteComment
  });
  const deleteCommentTranslations = getDeleteCommentTranslations();
  const handleDeleteCommentModalClose = useCallback(() => {
    setEngagementIdToDeleteComment(null);
    setCommentToDeleteId(null);
  }, []);
  const handleDeleteCommentModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_DELETE_COMMENT_MODAL) {
      setEngagementIdToDeleteComment(data.engagementId);
      setCommentToDeleteId(data.commentId);
      return;
    }
  }, []);
  const handleDeleteSuccess = useCallback(() => {
    FloatingAlertStore.addAlert({
      message: deleteCommentTranslations.successfulDelete,
      type: 'success',
      'data-alert-type': 'success'
    });
    handleDeleteCommentModalClose();
  }, [deleteCommentTranslations.successfulDelete, handleDeleteCommentModalClose]);
  const handleDeleteFailed = useCallback(error => {
    console.error(error);
    return FloatingAlertStore.addAlert({
      message: deleteCommentTranslations.failedDelete,
      type: 'danger',
      'data-alert-type': 'danger'
    });
  }, [deleteCommentTranslations.failedDelete]);
  const handleDeleteConfirm = useCallback(() => {
    deleteTimelineComment(engagementIdToDeleteComment, commentToDeleteId, handleDeleteSuccess, handleDeleteFailed);
    CrmLogger.log('timelineCommentsUsage', {
      action: `Delete comment`,
      activity: getEngagementTypeForTracking(engagementToDeleteComment),
      isRedesign: true
    });
  }, [commentToDeleteId, engagementIdToDeleteComment, engagementToDeleteComment, handleDeleteFailed, handleDeleteSuccess]);
  const renderedDeleteCommentModal = useMemo(() => {
    if (!engagementIdToDeleteComment && !commentToDeleteId) {
      return null;
    }
    return /*#__PURE__*/_jsx(TimelineCommentDeleteModalAsync, {
      "data-unit-test": "timeline-comment-delete-modal",
      onDeleteConfirm: handleDeleteConfirm,
      onDeleteReject: handleDeleteCommentModalClose
    });
  }, [commentToDeleteId, engagementIdToDeleteComment, handleDeleteCommentModalClose, handleDeleteConfirm]);
  return {
    handleDeleteCommentModalAction,
    commentDeleteModal: renderedDeleteCommentModal
  };
};